export type TNullable<T> = T | null;

// Network types
export enum Transmission {
  Sender = 'sender',
  Receiver = 'receiver',
}
export interface ChatMessage {
  id: number;
  message: string;
  timestamp: Date;
  sender: string;
  transmission: Transmission;
  meta: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}
export interface INlpRequest {
  query: string;
  topicId: string;
  instanceId: string;
}
export interface IDocument {
  id: string;
  displayName: string;
  createdAt: string;
  updatedAt: string;
  externalDocumentLink: string;
  hits: number;
  last_time_seen: string;
  content?: string;
}
export interface IQuestionOption {
  questionId: string;
  optionType: 'CERTAIN_OPTION' | 'UNCERTAIN_OPTION';
  actualQuery: string;
  answer: string;
  status: string;
  paraphrases: string[];
  sourceDocuments: Array<Pick<IDocument, 'id' | 'displayName' | 'externalDocumentLink'>>;
  similarity: number;
}
export interface IQuery {
  id: string;
  query: string;
  processingTime: number;
  createdAt: string;
  updatedAt: string;
  question: string;
}
export interface INlpResponse {
  query?: Pick<IQuery, 'id' | 'query'>;
  questionOptions?: IQuestionOption[];
  error?: string;
  status?: number;
}
export interface ITopic {
  id: string;
  name: string;
  displayName: string;
  keywords: string[];
  docs: Array<{
    content: string;
    createdAt: string;
    displayName: string;
    enabled: boolean;
    externalUrl: string;
    filePath: string;
    id: string;
    name: string;
    topic: string;
    type: string;
    uniqueKey: string;
    updatedAt: string;
  }>;
}

export interface ISaveFeedbackRequest {
  queryId: string;
  questionId: string;
  value: string;
}
export enum MessageType {
  Response = 'response',
  Message = 'message',
  Error = 'error',
  UserEntry = 'userentry',
  ChoiceResponse = 'choiceResponse',
  NoAnswerResponse = 'noanswerresponse',
  ForceMedInfo = 'forcemedinfo',
  InvalidQuery = 'invalidQuery',
}
export interface IMessage {
  id: number;
  message: string;
  sourceDocuments?: Array<Pick<IDocument, 'id' | 'displayName' | 'externalDocumentLink'>>;
  questionQuery?: string;
  type?: MessageType;
  questionId?: string;
  choices?: IQuestionOption[];
  queryId?: string;
}
export enum Feedback {
  Like = '1',
  Dislike = '0',
}
export interface IModalContent {
  title: string;
  text: string | React.ReactNode;
}
export enum Modals {
  MedicalInfo = 'medical-info',
}
export interface IPDFSection {
  title: string;
  section_number: string;
  page: number;
  coordinates: {
    x: number;
    y: number;
  };
  width: number;
  height: number;
}
export interface IPDFDetailsResponse {
  display_name: string;
  pdf_file_url: string;
  page_width: number;
  page_height: number;
  section_coordination_list: Array<IPDFSection>;
}
